import { render, staticRenderFns } from "./GroupPurchaseList.vue?vue&type=template&id=88057384&scoped=true"
import script from "./GroupPurchaseList.vue?vue&type=script&lang=js"
export * from "./GroupPurchaseList.vue?vue&type=script&lang=js"
import style0 from "./GroupPurchaseList.vue?vue&type=style&index=0&id=88057384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88057384",
  null
  
)

export default component.exports